import { render } from "./StandardCampaignGoal.vue?vue&type=template&id=968e27d2&scoped=true"
import script from "./StandardCampaignGoal.vue?vue&type=script&lang=js"
export * from "./StandardCampaignGoal.vue?vue&type=script&lang=js"

import "./StandardCampaignGoal.vue?vue&type=style&index=0&id=968e27d2&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-968e27d2"]])

export default __exports__